export default {
  padding: { vertical: '26px', horizon: '20px' },
  margin: {
    bottom: '30px',
  },
  closeButton: {
    top: '0.625rem',
    right: '0.625rem',
    width: '2.5rem',

    mdWidth: '2.8125rem',
    outline: {
      borderRadius: '20px',
      offset: '5px',
      md: {
        borderRadius: '25px',
        offset: '10px',
      },
    },
  },
  closeIcon: {
    width: '10px',
    height: '10px',
    md: {
      width: '15px',
      height: '15px',
    },
  },
};
